import { PERMISSION } from '@/constants/permission.constant';

const List = () => import('@/views/slider/List.vue');
const Add = () => import('@/views/slider/Add.vue');
const Edit = () => import('@/views/slider/Edit.vue');

export const sliderRoute = [
  {
    path: '/slider',
    name: 'slider-list',
    component: List,
    meta: { requiresAuth: false, permissions: [PERMISSION.SLIDER_MANAGEMENT_READ] },
  },

  {
    path: '/slider/create',
    name: 'slider-create',
    component: Add,
    meta: { requiresAuth: false, permissions: [PERMISSION.SLIDER_MANAGEMENT_CREATE] },
  },

  {
    path: '/slider/edit',
    name: 'slider-edit',
    component: Edit,
    meta: { requiresAuth: false, permissions: [PERMISSION.SLIDER_MANAGEMENT_UPDATE] },
  },
];
